// extracted by mini-css-extract-plugin
export default {"wrap":"lG-z","subtitle":"mG-z","contentWrap":"nG-z","imgWrap":"oG-z","heading":"pG-z","copy":"qG-z"};